import actionTypes, * as actionGroups from "shared/imports/global-action-types"
import { sendAction, resourceGetList } from "shared/djangio/action-creators"
import { getLedgerSettingsActionDict } from "shared/pac/types"

export const updateUserdata = updateArgs => ({
    type: actionTypes.UPDATE_USERDATA,
    updateArgs,
})

const shouldCheckCache = true
export const getTeams = () => resourceGetList(
    DjangIO.app.userdata.models.Team,
    actionGroups.getTeamsTypes,
    { limit: 150 },
    {},
    shouldCheckCache
)

/*
 * registerPushNotificationToken
 * sends a freshly generated token, new or old, to be registered to the current user
 * Args:
 * {
    token: (string) token pulled from PushNotification, as requested from apns or firebase,
    os: (number) the phone's base operating system, from MobileOS enum,
    delivery_network: (number) the dn responsible for this token, from DeliveryNetwork enum,
    user_id: (number) the user tagge to this token
    device_id: (string) the unique identifying string for the device in which token was generated
 }
 *
 */
export const registerPushNotificationToken = ({ token, os, delivery_network, user_id, device_id }) => sendAction(
    DjangIO.app.userdata.models.QuorumUser,
    actionGroups.registerPushToken,
    {
        method: "post",
        action: "push_notification_token",
        kwargs: { os, token, user_id, device_id, delivery_network }
    }
)


/*
 * resetPushNotificationUnseenCount
 * resets the number of push notifications the user has seen
 * Args:
 * {
    user_id: (number) the user that is logged in (and thus has seen the notifs)
 }
 *
 */
export const resetPushNotificationUnseenCount = ({ user_id }) => sendAction(
    DjangIO.app.userdata.models.QuorumUser,
    actionGroups.registerPushToken,
    {
        method: "patch",
        action: "reset_push_notification_unseen_count",
        kwargs: {},
    }
)


export const getTeamMembers = () => resourceGetList(
    DjangIO.app.userdata.models.LiteQuorumUser,
    actionGroups.getTeamMembersTypes,
    {
        limit: 0,
        for_mentions: true,
    },
    {},
    shouldCheckCache
)

export const getLedgers = () => resourceGetList(
    DjangIO.app.ledger.models.LedgerSettings,
    getLedgerSettingsActionDict,
    {},
    {},
    shouldCheckCache
)
